import angular from 'angular';

angular.module('cloudX').directive('cxCurrency', [
  'optionsSvc',
  function(optionsSvc) {
    return {
      restrict: 'E',
      replace: true,
      template:
        '<select ng-model="currency" ng-options="(currency.code | translateList:\'currency\':currency.name) for currency in currencies track by currency.code" ' +
        'class="form-control input-sm" ng-change="selecting()"></select>',
      scope: {
        currency: '=data',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.currencies = optionsSvc.getOptionsWithDefault('currency');
          $scope.selecting = function() {
            $scope.currencies = optionsSvc.getOptions('currency');
          };
        },
      ],
    };
  },
]);
